import {
    MiddlewareAPI,
    isRejectedWithValue,
    Middleware,
} from '@reduxjs/toolkit'
import { toaster } from "baseui/toast";
import { reactPlugin } from "../AppInsights";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { apiConfig } from '../config';
import { HttpErrorMessage } from '../components/HttpErrorMsg';

const overrides = {
    InnerContainer: {
        style: { width: "100%" }
    }
}

/**
 * Log a warning and show a notification!
 */
export const errorMiddleware: Middleware =
    (api: MiddlewareAPI) => (next) => (action: any) => {
        // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
        if (isRejectedWithValue(action)) {
            reactPlugin.trackException({ error: { name: action.error.name ?? 'unknown name', message: action.error.message ?? 'unknown error' },severityLevel: SeverityLevel.Error }, { "payload": action.payload });


            const httpstatus = action.payload.originalStatus ?? action.payload.status;
            //if (apiConfig.isDevelopment) {
            if (httpstatus === 403) {
                console.warn('Access denied', action)
                /*if (apiConfig.isDevelopment) {
                    toaster.negative(<HttpErrorMessage message={'Access was denied for resource\n' + action.type} httpstatus={httpstatus} />, { autoHideDuration: 5000, overrides: overrides })
                }*/
            }
            else if (httpstatus === 400) {
                console.error('Bad Request', action)
                if (action.payload.data && typeof action.payload.data === 'string')
                        toaster.negative(<HttpErrorMessage message={JSON.stringify(action.payload.data)} httpstatus={httpstatus} />, {
                            autoHideDuration: 5000, overrides: overrides
                        })
                    else
                        toaster.negative(<HttpErrorMessage message={JSON.stringify(action.payload.data)} httpstatus={httpstatus} />, {
                            autoHideDuration: 5000, overrides: overrides
                        })
            }
            else if (httpstatus === 401) {
                console.warn('Access denied', action)
                /*if (apiConfig.isDevelopment) {
                    toaster.negative(<HttpErrorMessage message={'Access not authorized\n' + action.type} httpstatus={httpstatus} />, {
                        autoHideDuration: 5000, overrides: overrides
                    })
                }*/
            }
            else if (httpstatus === 500) {
                console.error('Internal Server Error', action)
                toaster.negative(<HttpErrorMessage message={'An error occured in backend'} httpstatus={httpstatus} />, {
                    autoHideDuration: 5000, overrides: overrides
                })
                /*if (apiConfig.isDevelopment) {
                    toaster.negative(<HttpErrorMessage message={'An error occured in backend'} httpstatus={httpstatus} />, {
                        autoHideDuration: 5000, overrides: overrides
                    })
                }*/
            }
            else if (httpstatus === 503) {
                console.warn('The backend service is currently not running', action)
                /*if (apiConfig.isDevelopment) {
                    toaster.negative(<HttpErrorMessage message={'The backend service is currently not running - please retry'} httpstatus={httpstatus} />, {
                        autoHideDuration: 3000, overrides: overrides
                    })
                }*/
            }
            else {
                console.error('Error call backend', action);
                /*if (apiConfig.isDevelopment) {
                    if (action.error && action.error.data && action.error.data.message) {
                        //console.warn('Error call backend' + action.payload.status + action.error.data.message)
                        toaster.negative(<HttpErrorMessage message={'Error call backend.\n' + action.payload.status + action.error.data.message} httpstatus={httpstatus} />, {
                            autoHideDuration: 5000, overrides: overrides
                        })
                    }
                    else {
                        //console.error('Error call backend' + action.payload.status + action.type)
                        toaster.negative(<HttpErrorMessage message={'Error call backend.\n' + action.payload.status + action.type} httpstatus={httpstatus} />, {
                            autoHideDuration: 5000, overrides: overrides
                        })
                    }
                }*/
            }
        }

        return next(action)
    }